export default __webpack_public_path__ + "media/images/images/flags/nd-36498fc7e4b3f64c22ff3e97133e09a5.png";